import { MONTH_PASCAL, MONTH_TRUNCATED } from '../constants';

const truncatePascalMonth = (month: MONTH_PASCAL): MONTH_TRUNCATED => {
  switch (month) {
    case MONTH_PASCAL.JANUARY:
      return MONTH_TRUNCATED.JAN;
    case MONTH_PASCAL.FEBRUARY:
      return MONTH_TRUNCATED.FEB;
    case MONTH_PASCAL.MARCH:
      return MONTH_TRUNCATED.MAR;
    case MONTH_PASCAL.APRIL:
      return MONTH_TRUNCATED.APR;
    case MONTH_PASCAL.MAY:
      return MONTH_TRUNCATED.MAY;
    case MONTH_PASCAL.JUNE:
      return MONTH_TRUNCATED.JUN;
    case MONTH_PASCAL.JULY:
      return MONTH_TRUNCATED.JUL;
    case MONTH_PASCAL.AUGUST:
      return MONTH_TRUNCATED.AUG;
    case MONTH_PASCAL.SEPTEMBER:
      return MONTH_TRUNCATED.SEP;
    case MONTH_PASCAL.OCTOBER:
      return MONTH_TRUNCATED.OCT;
    case MONTH_PASCAL.NOVEMBER:
      return MONTH_TRUNCATED.NOV;
    case MONTH_PASCAL.DECEMBER:
      return MONTH_TRUNCATED.DEC;
  }
};

export default truncatePascalMonth;
